import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "./TabCardHeader";
import MaterialStyleNav from "./TabStyleNav";
import MaterialStyleContent from "./MaterialStyleContent";

export interface CommonCardHeaderProps {
  headClass?: string;
  title: string;
  subTitle: string;
  titleClass?: string;

}

export default function MaterialStyleTab() {
  const [basicTab, setBasicTab] = useState("1");
  const [filter, setFilter] = useState("");

  // Handle search input change
  const filterHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(e.target.value);
    console.log("Filter search:", e.target.value);
  };

  // Clear search filter
  const clearFilter = () => {
    setFilter("");
  };

  return (
    <Col xxl={12}>
      <Card className="title-line countries_flagWrapper">
        <CommonCardHeader title="Countries" subTitle="" />
        <CardBody>
          <MaterialStyleNav
            basicTab={basicTab}
            setBasicTab={setBasicTab}
            filterValue={filter}
            onFilterChange={filterHandler}
            clearFilter={clearFilter} // Pass clearFilter function
          />
          <MaterialStyleContent tabId={basicTab} filter={filter} />
        </CardBody>
      </Card>
    </Col>
  );
}
